import { useQuery } from '@tanstack/react-query';
import API, { getMediaURL } from '../../../../context/API';
import { SoldOutItem } from '../types';
import { QUERY_KEYS } from '../constants';

interface SoldOutPage {
  items: SoldOutItem[];
  total: number;
}

function sortByUpdatedAt(data: SoldOutItem[]): SoldOutItem[] {
  return [...data].sort(
    (a, b) => new Date(b.updatedAt || 0).getTime() - new Date(a.updatedAt || 0).getTime()
  );
}

async function fetchSoldOutItems(page: number, limit: number, search: string): Promise<SoldOutPage> {
  const response = await API.get(
    `/items/stock?soldOut=true&page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`
  );
  const items = sortByUpdatedAt(
    response.data.data.map((item: SoldOutItem) => ({
      ...item,
      picture: getMediaURL(item.picture),
    }))
  );
  return { items, total: response.data.total };
}

export function useSoldOutQuery(search: string, page: number, pageSize: number, enabled = true) {
  return useQuery({
    queryKey: [QUERY_KEYS.SOLD_OUT_ITEMS, search, page, pageSize],
    queryFn: () => fetchSoldOutItems(page, pageSize, search),
    staleTime: 0,
    placeholderData: (prev) => prev,
    enabled,
  });
}
